import { render, staticRenderFns } from "./DialogTip.vue?vue&type=template&id=0764d18f&"
import script from "./DialogTip.vue?vue&type=script&lang=js&"
export * from "./DialogTip.vue?vue&type=script&lang=js&"
import style0 from "./DialogTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports